import { useField } from "formik";
import useDependentField, {
  usePropertyExtractor,
} from "../../hooks/use-dependent-field";
import CheckboxStandalone from "./CheckboxStandalone";

export default function Checkbox({ dependon, ...props }) {
  const [field] = useField({ ...props, type: "checkbox" });
  useDependentField(props.name, dependon, usePropertyExtractor(props.name));
  return <CheckboxStandalone {...field} {...props} />;
}
